import { TabNavigation } from 'src/common/TabNavigation';

const tabs = [
  { name: 'Internal', href: '/admin/internal' },
  { name: 'Logs', href: '/admin/logs' },
  { name: 'MTM', href: '/admin/mtm' },
  { name: 'Momentm', href: '/admin/momentm' },
  { name: 'Kinetik', href: '/admin/kinetik' },
  { name: 'Modivcare', href: '/admin/modivcare' },
  { name: 'Alivi', href: '/admin/alivi' },
  { name: 'Clearview', href: '/admin/clearview' },
];

export function AdminNav() {
  return <TabNavigation tabs={tabs} />;
}
